// @flow

import { log } from './jsUtils';
import { getOnboardingRedirect } from './onboardingUtils';

const pathAuth = [
  {
    pathname: '/member',
    restricted: true
  },
  {
    pathname: '/properties',
    restricted: true
  },
  {
    pathname: '/property',
    restricted: true
  },
  {
    pathname: '/',
    restricted: false
  },
  {
    pathname: '/login',
    restricted: false
  },
  {
    pathname: '/register',
    restricted: false
  }
];

/**
 * Redirect user based on their account status and onboarding progress.
 * Uses centralized onboarding logic from onboardingUtils.js.
 *
 * @param {Object} history - React Router history object
 * @param {Object} store - Object containing user, billing, and defaultBuilding state
 */
export const redirectBasedOnAccountStatus = (history: Object, store: Object): void => {
  const {
    user,
    billing,
    defaultBuilding
  } = store;

  log('[redirectBasedOnAccountStatus] store: ', store);
  const currentPath = history.location.pathname;
  log('[redirectBasedOnAccountStatus] currentPath: ', currentPath);

  // Skip redirect for authorization flow
  if (currentPath === '/authorize') {
    return;
  }

  log('[redirectBasedOnAccountStatus] user: ', user);
  log('[redirectBasedOnAccountStatus] billing: ', billing);

  // Use centralized onboarding redirect logic
  const redirect = getOnboardingRedirect(currentPath, {
    user,
    billing,
    defaultBuilding
  });

  if (redirect) {
    log('[redirectBasedOnAccountStatus] redirect to', redirect);
    history.push(redirect);
    return;
  }

  // PERFORMANCE OPTIMIZATION: Only redirect for billing issues if user is trying to access billing-restricted content
  // This is separate from onboarding - it handles users who have completed onboarding but have billing issues
  const billingRestrictedPaths = ['/billing', '/checkout'];
  const isBillingRestrictedPath = billingRestrictedPaths.includes(currentPath);

  if (isBillingRestrictedPath && (typeof billing === 'undefined' || billing.planId === null || billing.planId === undefined)) {
    // Only redirect to plans if user is on a billing-specific page and has no plan
    log('[redirectBasedOnAccountStatus] redirect to /plans - billing required for current page');
    history.push('/plans');
    return;
  }

  // PERFORMANCE OPTIMIZATION: If no redirects are needed, let user stay on current page
  // This allows optimistic routing to work - user can see content while billing loads
  log('[redirectBasedOnAccountStatus] no redirect needed - allowing optimistic routing');
};

export default {
  pathAuth: pathAuth
};
